import axios from 'axios'

export const enviarMensaje = async (data) => {
    try {
        const enviado = await axios.post("https://send-mail-three.vercel.app/", data)
        return {respuesta: enviado.data}
    } catch (error) {
        throw error
    }
}